import qs from 'qs';
import { client } from './client';
import interceptors from '@/api/interceptors';

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function login(username, password) {
	return client.post('/tunnel/api/public/login', qs.stringify({ type: 'member', username, password }), {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

export { login };
